"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyProgram = exports.TokenProgram = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const addressParser_1 = require("./addressParser");
const client_1 = require("./client");
const tokens_1 = require("./data/tokens");
const decoder_1 = require("./decoder");
const prices_1 = require("./prices");
const protocols_1 = require("./protocols");
const francium = __importStar(require("./protocols/francium"));
const mango = __importStar(require("./protocols/mango"));
const port = __importStar(require("./protocols/port"));
const solend = __importStar(require("./protocols/solend"));
const solendStablePool = __importStar(require("./protocols/solendStablePool"));
const tulip = __importStar(require("./protocols/tulip"));
const tokensParser_1 = require("./tokensParser");
function sortedIndices(list) {
    const len = list.length;
    const indices = new Array(len);
    for (let i = 0; i < len; ++i)
        indices[i] = i;
    indices.sort(function (a, b) {
        return list[a].lt(list[b]) ? -1 : 1;
    });
    return indices;
}
// TODO read this const from idl
const WEIGHTS_SCALE = 10000;
// TODO should be exported in client and used here
class TokenProgram extends anchor_1.Program {
    constructor(idl, programId, provider, user) {
        var _a;
        super(idl, programId, provider);
        this.tokenInput = "WSOL";
        this.connection = provider === null || provider === void 0 ? void 0 : provider.connection;
        this.user = user !== null && user !== void 0 ? user : (_a = provider === null || provider === void 0 ? void 0 : provider.wallet) === null || _a === void 0 ? void 0 : _a.publicKey;
    }
    setToken(token) {
        if (Object.entries(tokens_1.TOKENS).some(([tkn, _tokenInfo]) => tkn === token)) {
            this.tokenInput = token;
        }
        else {
            throw "Token " + token + " does not exist :";
        }
    }
    decodeEvent(rawEvent) {
        const dec = new anchor_1.BorshEventCoder(this.idl);
        const event = dec.decode(rawEvent);
        if (!event) {
            throw "Cannot decode event " + rawEvent;
        }
        return event;
    }
}
exports.TokenProgram = TokenProgram;
class StrategyProgram extends TokenProgram {
    constructor() {
        super(...arguments);
        this.vaultKeys = (0, addressParser_1.addressParser)({
            group: "strategies",
            name: "bestApy",
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decodeVault(token = this.tokenInput) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultAccountInfo = yield this.connection.getAccountInfo(this.vaultKeys[token].vaultAccount);
            if (!vaultAccountInfo) {
                throw new Error("Vault account does not exist");
            }
            return this.coder.accounts.decode("VaultAccount", vaultAccountInfo.data);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decodeVaults() {
        return __awaiter(this, void 0, void 0, function* () {
            const accounts = [];
            for (const token of Object.keys(tokens_1.TOKENS)) {
                const publicKey = this.vaultKeys[token].vaultAccount;
                if (publicKey) {
                    accounts.push({
                        accountType: "Vault",
                        publicKey,
                    });
                }
            }
            return (0, decoder_1.decodeMultipleAccounts)(this, accounts);
        });
    }
    lpToAmount(lpAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const accounts = [
                { accountType: "Vault", publicKey: vaultKeys.vaultAccount },
                { accountType: "Mint", publicKey: vaultKeys.vaultLpTokenMintAddress },
            ];
            const [vault, mint] = yield (0, decoder_1.decodeMultipleAccounts)(this, accounts);
            // spl-token uses bigint
            mint.supply = new anchor_1.BN(mint.supply);
            return this.lpToAmountDecoded(lpAmount, vault.currentTvl, mint.supply);
        });
    }
    lpToAmountDecoded(lpAmount, currentTvl, supply) {
        return lpAmount.mul(currentTvl).div(supply);
    }
    amountToLp(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const accounts = [
                { accountType: "Vault", publicKey: vaultKeys.vaultAccount },
                { accountType: "Mint", publicKey: vaultKeys.vaultLpTokenMintAddress },
            ];
            const [vault, mint] = yield (0, decoder_1.decodeMultipleAccounts)(this, accounts);
            // spl-token uses bigint
            mint.supply = new anchor_1.BN(mint.supply);
            return this.amountToLpDecoded(amount, vault.currentTvl, mint.supply);
        });
    }
    amountToLpDecoded(amount, currentTvl, supply) {
        return amount.mul(supply).div(currentTvl);
    }
    initializeVault(accountNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenMint = (0, tokensParser_1.getMintAddress)(this.tokenInput);
            const [vaultAccount, _bump] = yield anchor_1.web3.PublicKey.findProgramAddress([
                Buffer.from("vault"),
                accountNumber.toBuffer("le", 1),
                tokenMint.toBuffer(),
            ], this.programId);
            const [vaultLpTokenMintAddress, _bump2] = yield anchor_1.web3.PublicKey.findProgramAddress([Buffer.from("mint"), vaultAccount.toBuffer()], this.programId);
            const vaultInputTokenAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(tokenMint, vaultAccount, true);
            // DAO treasury associated with deployer authority
            const daoTreasuryLpTokenAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(vaultLpTokenMintAddress, client_1.DAO_TREASURY_OWNER, false);
            this.vaultKeys[this.tokenInput].vaultAccount = vaultAccount;
            this.vaultKeys[this.tokenInput].vaultLpTokenMintAddress =
                vaultLpTokenMintAddress;
            this.vaultKeys[this.tokenInput].vaultInputTokenAccount =
                vaultInputTokenAccount;
            this.vaultKeys[this.tokenInput].daoTreasuryLpTokenAccount =
                daoTreasuryLpTokenAccount;
            if (yield this.connection.getAccountInfo(vaultAccount)) {
                console.log("vault accounts already initialized");
                return null;
            }
            else {
                return this.methods
                    .initializeVault(accountNumber)
                    .accounts({
                    userSigner: this.user,
                    inputTokenMintAddress: tokenMint,
                    vaultAccount,
                    vaultLpTokenMintPubkey: vaultLpTokenMintAddress,
                    vaultInputTokenAccount,
                    daoTreasuryLpTokenAccount,
                    daoTreasuryOwner: client_1.DAO_TREASURY_OWNER,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                })
                    .transaction();
            }
        });
    }
    initializeTicketMint() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const vaultLpTokenAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(vaultKeys.vaultLpTokenMintAddress, vaultKeys.vaultAccount, true);
            const [vaultTicketMintPubkey, _bump] = yield anchor_1.web3.PublicKey.findProgramAddress([Buffer.from("ticket_mint"), vaultKeys.vaultAccount.toBuffer()], this.programId);
            this.vaultKeys[this.tokenInput].vaultLpTokenAccount = vaultLpTokenAccount;
            this.vaultKeys[this.tokenInput].vaultTicketMintPubkey =
                vaultTicketMintPubkey;
            if (yield this.connection.getAccountInfo(vaultTicketMintPubkey)) {
                console.log("ticket_mint account already initialized");
                return null;
            }
            else {
                const tx = new anchor_1.web3.Transaction()
                    .add((0, spl_token_1.createAssociatedTokenAccountInstruction)(this.user, vaultLpTokenAccount, vaultKeys.vaultAccount, vaultKeys.vaultLpTokenMintAddress))
                    .add(yield this.methods
                    .initializeTicketMint()
                    .accounts({
                    userSigner: this.user,
                    vaultAccount: vaultKeys.vaultAccount,
                    vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
                    vaultTicketMintPubkey,
                    systemProgram: anchor_1.web3.SystemProgram.programId,
                    associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                })
                    .transaction());
                return tx;
            }
        });
    }
    createVaultUserTicketAccount(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const [vaultUserTicketAccount, _bump] = anchor_1.web3.PublicKey.findProgramAddressSync([
                Buffer.from("ticket_mint"),
                vaultKeys.vaultTicketMintPubkey.toBuffer(),
                this.user.toBuffer(),
            ], this.programId);
            return this.methods
                .createVaultUserTicketAccount()
                .accounts({
                userSigner: params.userSigner,
                userTicketAccountOwner: params.userTicketAccountOwner,
                vaultUserTicketAccount,
                vaultAccount: vaultKeys.vaultAccount,
                vaultTicketMintPubkey: vaultKeys.vaultTicketMintPubkey,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            })
                .instruction();
        });
    }
    setProtocolWeights(weights) {
        return __awaiter(this, void 0, void 0, function* () {
            const sum = weights.reduce((acc, x) => acc + x, 0);
            if (sum != 0 && sum != WEIGHTS_SCALE) {
                throw new Error("Invalid protocol weights values");
            }
            const vaultKeys = this.vaultKeys[this.tokenInput];
            return this.methods
                .setProtocolWeights(weights)
                .accounts({
                userSigner: this.user,
                vaultAccount: vaultKeys.vaultAccount,
            })
                .transaction();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setRefreshParams(refreshParams) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.methods
                .setRefreshParams(refreshParams)
                .accounts({
                userSigner: this.user,
                vaultAccount: this.vaultKeys[this.tokenInput].vaultAccount,
            })
                .transaction();
        });
    }
    initializeProtocolAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultData = yield this.decodeVault();
            const txs = [];
            for (const data of vaultData.protocols) {
                if (data.weight != 0) {
                    switch (data.protocolId) {
                        case protocols_1.Protocols.Mango:
                            txs.push(yield mango.initializeProtocol(this));
                            break;
                        case protocols_1.Protocols.Port:
                            txs.push(yield port.initializeProtocol(this));
                            break;
                        case protocols_1.Protocols.Solend:
                            txs.push(yield solend.initializeProtocol(this));
                            break;
                        case protocols_1.Protocols.Tulip:
                            txs.push(yield tulip.initializeProtocol(this));
                            break;
                        case protocols_1.Protocols.Francium:
                            txs.push(yield francium.initializeProtocol(this));
                            break;
                        case protocols_1.Protocols.SolendStablePool:
                            txs.push(yield solendStablePool.initializeProtocol(this));
                            break;
                    }
                }
            }
            return txs;
        });
    }
    setHashes() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultData = yield this.decodeVault();
            const txs = [];
            for (const data of vaultData.protocols) {
                if (data.weight != 0) {
                    switch (data.protocolId) {
                        case protocols_1.Protocols.Mango:
                            txs.push(yield mango.setHashes(this));
                            break;
                        case protocols_1.Protocols.Port:
                            txs.push(yield port.setHashes(this));
                            break;
                        case protocols_1.Protocols.Solend:
                            txs.push(yield solend.setHashes(this));
                            break;
                        case protocols_1.Protocols.Tulip:
                            txs.push(yield tulip.setHashes(this));
                            break;
                        case protocols_1.Protocols.Francium:
                            txs.push(yield francium.setHashes(this));
                            break;
                        case protocols_1.Protocols.SolendStablePool:
                            txs.push(yield solendStablePool.setHashes(this));
                            break;
                    }
                }
            }
            return txs;
        });
    }
    deposit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.depositBuilder(params).transaction();
        });
    }
    getDepositIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.depositBuilder(params).instruction();
        });
    }
    depositBuilder(params) {
        const vaultKeys = this.vaultKeys[this.tokenInput];
        return this.methods.deposit(params.amount).accounts({
            userSigner: this.user,
            userInputTokenAccount: params.userInputTokenAccount,
            userLpTokenAccount: params.userLpTokenAccount,
            vaultAccount: vaultKeys.vaultAccount,
            vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
            vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        });
    }
    depositFromNative(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.depositFromNativeBuilder(params).transaction();
        });
    }
    getDepositFromNativeIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.depositFromNativeBuilder(params).instruction();
        });
    }
    depositFromNativeBuilder(params) {
        const vaultKeys = this.vaultKeys[this.tokenInput];
        return this.methods.depositFromNative(params.amount).accounts({
            userSigner: this.user,
            userWrappedAccount: params.userWrappedAccount,
            userLpTokenAccount: params.userLpTokenAccount,
            vaultAccount: vaultKeys.vaultAccount,
            vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
            vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        });
    }
    rebalance() {
        return __awaiter(this, void 0, void 0, function* () {
            let RebalanceActions;
            (function (RebalanceActions) {
                RebalanceActions[RebalanceActions["Deposit"] = 0] = "Deposit";
                RebalanceActions[RebalanceActions["Withdraw"] = 1] = "Withdraw";
            })(RebalanceActions || (RebalanceActions = {}));
            const vaultData = yield this.decodeVault();
            const amount = vaultData.currentTvl;
            const protocolActions = [];
            vaultData.protocols.forEach((data) => {
                const protocolId = data.protocolId;
                const weight = new anchor_1.BN(data.weight);
                const currentDeposit = data.amount;
                const targetDeposit = amount.mul(weight).div(new anchor_1.BN(WEIGHTS_SCALE));
                if (currentDeposit.gt(targetDeposit)) {
                    protocolActions.push([protocolId, RebalanceActions.Withdraw]);
                }
                else if (currentDeposit.lt(targetDeposit)) {
                    protocolActions.push([protocolId, RebalanceActions.Deposit]);
                }
            });
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const genericDepositAccounts = {
                vaultAccount: vaultKeys.vaultAccount,
                vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            };
            const genericWithdrawAccounts = {
                vaultAccount: vaultKeys.vaultAccount,
                vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
            };
            // Make withdraws first
            const txsW = [];
            for (const [protocolId, action] of protocolActions) {
                if (action === RebalanceActions.Withdraw) {
                    switch (protocolId) {
                        case protocols_1.Protocols.Mango:
                            txsW.push(yield mango.withdraw(this, genericWithdrawAccounts));
                            break;
                        case protocols_1.Protocols.Solend:
                            txsW.push(yield solend.withdraw(this, genericWithdrawAccounts));
                            break;
                        case protocols_1.Protocols.Port:
                            txsW.push(yield port.withdraw(this, genericWithdrawAccounts));
                            break;
                        case protocols_1.Protocols.Tulip:
                            txsW.push(yield tulip.withdraw(this, genericWithdrawAccounts));
                            break;
                        case protocols_1.Protocols.Francium:
                            txsW.push(yield francium.withdraw(this, genericWithdrawAccounts));
                            break;
                        case protocols_1.Protocols.SolendStablePool:
                            txsW.push(yield solendStablePool.withdraw(this, genericWithdrawAccounts));
                            break;
                    }
                }
            }
            const txsD = [];
            for (const [protocolId, action] of protocolActions) {
                if (action === RebalanceActions.Deposit) {
                    switch (protocolId) {
                        case protocols_1.Protocols.Mango:
                            txsD.push(yield mango.deposit(this, genericDepositAccounts));
                            break;
                        case protocols_1.Protocols.Solend:
                            txsD.push(yield solend.deposit(this, genericDepositAccounts));
                            break;
                        case protocols_1.Protocols.Port:
                            txsD.push(yield port.deposit(this, genericDepositAccounts));
                            break;
                        case protocols_1.Protocols.Tulip:
                            txsD.push(yield tulip.deposit(this, genericDepositAccounts));
                            break;
                        case protocols_1.Protocols.Francium:
                            txsD.push(yield francium.deposit(this, genericDepositAccounts));
                            break;
                        case protocols_1.Protocols.SolendStablePool:
                            txsD.push(yield solendStablePool.deposit(this, genericDepositAccounts));
                            break;
                    }
                }
            }
            return [txsW, txsD];
        });
    }
    openWithdrawTicket(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.openWithdrawTicketBuilder(params).transaction();
        });
    }
    getOpenWithdrawTicketIx(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.openWithdrawTicketBuilder(params).instruction();
        });
    }
    openWithdrawTicketBuilder(params) {
        const vaultKeys = this.vaultKeys[this.tokenInput];
        const [vaultUserTicketAccount, bump] = anchor_1.web3.PublicKey.findProgramAddressSync([
            Buffer.from("ticket_mint"),
            vaultKeys.vaultTicketMintPubkey.toBuffer(),
            this.user.toBuffer(),
        ], this.programId);
        return this.methods.openWithdrawTicket(bump, params.lpAmount).accounts({
            userSigner: this.user,
            userLpTokenAccount: params.userLpTokenAccount,
            vaultUserTicketAccount,
            vaultAccount: vaultKeys.vaultAccount,
            vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
            vaultTicketMintPubkey: vaultKeys.vaultTicketMintPubkey,
            vaultLpTokenAccount: vaultKeys.vaultLpTokenAccount,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        });
    }
    withdrawFromProtocolsAmountsAndTxs(lpAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const accounts = [
                { accountType: "Vault", publicKey: vaultKeys.vaultAccount },
                { accountType: "Mint", publicKey: vaultKeys.vaultLpTokenMintAddress },
                { accountType: "Account", publicKey: vaultKeys.vaultInputTokenAccount },
            ];
            const [vault, mint, token] = yield (0, decoder_1.decodeMultipleAccounts)(this, accounts);
            // spl-token uses bigint
            mint.supply = new anchor_1.BN(mint.supply);
            token.amount = new anchor_1.BN(token.amount);
            // Internally, the previous lp-price is used but this is more conservative
            const vaultInputTokenAmount = token.amount;
            const amount = this.lpToAmountDecoded(lpAmount, vault.currentTvl, mint.supply);
            const amountsAndTxs = [];
            if (amount.gt(vaultInputTokenAmount)) {
                const genericAccounts = {
                    vaultAccount: vaultKeys.vaultAccount,
                    vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
                    tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                    clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                    instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
                };
                const protocolIds = vault.protocols.map((p) => p.protocolId);
                const deposited = vault.protocols.map((p) => p.amount);
                // Sort from higher to lower
                const reverseIndx = sortedIndices(deposited).reverse();
                let withdrawn = new anchor_1.BN(0);
                for (let i = 0; i < reverseIndx.length; ++i) {
                    const protocolIdx = reverseIndx[i];
                    let depositedAmount = deposited[protocolIdx];
                    if (depositedAmount.eq(new anchor_1.BN(0)))
                        continue;
                    if (i == 0) {
                        depositedAmount = depositedAmount.add(vaultInputTokenAmount);
                    }
                    const maxLpDeposited = this.amountToLpDecoded(depositedAmount, vault.currentTvl, mint.supply);
                    let toWithdraw = lpAmount.sub(withdrawn);
                    if (toWithdraw.gt(maxLpDeposited))
                        toWithdraw = maxLpDeposited;
                    let tx = new anchor_1.web3.Transaction();
                    switch (protocolIds[protocolIdx]) {
                        case protocols_1.Protocols.Mango:
                            tx = yield mango.withdraw(this, genericAccounts);
                            break;
                        case protocols_1.Protocols.Solend:
                            tx = yield solend.withdraw(this, genericAccounts);
                            break;
                        case protocols_1.Protocols.Port:
                            tx = yield port.withdraw(this, genericAccounts);
                            break;
                        case protocols_1.Protocols.Tulip:
                            tx = yield tulip.withdraw(this, genericAccounts);
                            break;
                        case protocols_1.Protocols.Francium:
                            tx = yield francium.withdraw(this, genericAccounts);
                            break;
                        case protocols_1.Protocols.SolendStablePool:
                            tx = yield solendStablePool.withdraw(this, genericAccounts);
                            break;
                    }
                    amountsAndTxs.push([toWithdraw, tx]);
                    withdrawn = withdrawn.add(toWithdraw);
                    if (lpAmount.lte(withdrawn)) {
                        break;
                    }
                }
            }
            return amountsAndTxs;
        });
    }
    closeWithdrawTicket(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const [vaultUserTicketAccount, bump] = anchor_1.web3.PublicKey.findProgramAddressSync([
                Buffer.from("ticket_mint"),
                vaultKeys.vaultTicketMintPubkey.toBuffer(),
                this.user.toBuffer(),
            ], this.programId);
            const closeWithdrawTicketAccounts = {
                userSigner: this.user,
                userInputTokenAccount: params.userInputTokenAccount,
                vaultUserTicketAccount,
                vaultAccount: vaultKeys.vaultAccount,
                vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
                vaultTicketMintPubkey: vaultKeys.vaultTicketMintPubkey,
                vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
                vaultLpTokenAccount: vaultKeys.vaultLpTokenAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            };
            const amountsAndTxs = yield this.withdrawFromProtocolsAmountsAndTxs(params.lpAmount);
            const txs = [];
            if (amountsAndTxs.length === 0) {
                txs.push(yield this.methods
                    .closeWithdrawTicket(bump, params.lpAmount)
                    .accounts(closeWithdrawTicketAccounts)
                    .transaction());
            }
            else {
                for (const [lpAmount, txProtocol] of amountsAndTxs) {
                    // Append the withdraw (from vault) tx
                    txs.push(txProtocol.add(yield this.methods
                        .closeWithdrawTicket(bump, lpAmount)
                        .accounts(closeWithdrawTicketAccounts)
                        .transaction()));
                }
            }
            return txs;
        });
    }
    withdraw(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const withdrawAccounts = {
                userSigner: this.user,
                userLpTokenAccount: params.userLpTokenAccount,
                userInputTokenAccount: params.userInputTokenAccount,
                vaultAccount: vaultKeys.vaultAccount,
                vaultInputTokenAccount: vaultKeys.vaultInputTokenAccount,
                vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            };
            const amountsAndTxs = yield this.withdrawFromProtocolsAmountsAndTxs(params.lpAmount);
            const txs = [];
            if (amountsAndTxs.length === 0) {
                txs.push(yield this.methods
                    .withdraw(params.lpAmount)
                    .accounts(withdrawAccounts)
                    .transaction());
            }
            else {
                for (const [lpAmount, txProtocol] of amountsAndTxs) {
                    // Append the withdraw (from vault) tx
                    txs.push(txProtocol.add(yield this.methods
                        .withdraw(lpAmount)
                        .accounts(withdrawAccounts)
                        .transaction()));
                }
            }
            return txs;
        });
    }
    refreshWeights() {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultKeys = this.vaultKeys[this.tokenInput];
            const genericAccounts = {
                vaultAccount: vaultKeys.vaultAccount,
            };
            const vaultData = yield this.decodeVault();
            const txs = [];
            for (const data of vaultData.protocols) {
                if (data.weight != 0) {
                    switch (data.protocolId) {
                        case protocols_1.Protocols.Mango:
                            txs.push(yield mango.tvl(this, genericAccounts));
                            break;
                        case protocols_1.Protocols.Port:
                            txs.push(yield port.tvl(this, genericAccounts));
                            break;
                        case protocols_1.Protocols.Solend:
                            txs.push(yield solend.tvl(this, genericAccounts));
                            break;
                        case protocols_1.Protocols.Tulip:
                            txs.push(yield tulip.tvl(this, genericAccounts));
                            break;
                        case protocols_1.Protocols.Francium:
                            txs.push(yield francium.tvl(this, genericAccounts));
                            break;
                        case protocols_1.Protocols.SolendStablePool:
                            txs.push(yield solendStablePool.tvl(this, genericAccounts));
                            break;
                    }
                }
            }
            const refreshIx = yield this.methods
                .refreshWeights()
                .accounts({
                vaultAccount: vaultKeys.vaultAccount,
                vaultLpTokenMintPubkey: vaultKeys.vaultLpTokenMintAddress,
                daoTreasuryLpTokenAccount: vaultKeys.daoTreasuryLpTokenAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            })
                .instruction();
            return new anchor_1.web3.Transaction().add(...txs, refreshIx);
        });
    }
    closeAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.methods
                .closeAccount()
                .accounts({
                vaultAccount: this.vaultKeys[this.tokenInput].vaultAccount,
            })
                .transaction();
        });
    }
    tvl(token = this.tokenInput) {
        return __awaiter(this, void 0, void 0, function* () {
            const vaultAccount = yield this.decodeVault(token);
            return vaultAccount.currentTvl;
        });
    }
    tvlUSD(token = this.tokenInput) {
        return __awaiter(this, void 0, void 0, function* () {
            const tvl = yield this.tvl(token);
            const scale = new anchor_1.BN(Math.pow(10, tokens_1.TOKENS[token].decimals));
            const tokenPrice = yield (0, prices_1.getPrice)(token);
            return tvl.div(scale).mul(new anchor_1.BN(tokenPrice));
        });
    }
    tvlUSDAllTokens() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const vaultAccounts = yield this.decodeVaults();
            const prices = yield (0, prices_1.getPrices)();
            let i = 0;
            let totalTvl = new anchor_1.BN(0);
            // decoded in the same order than TOKENS keys (if pubkey exists)
            for (const token of Object.keys(tokens_1.TOKENS)) {
                if (this.vaultKeys[token].vaultAccount) {
                    const tvl = vaultAccounts[i++].currentTvl;
                    const scale = new anchor_1.BN(Math.pow(10, tokens_1.TOKENS[token].decimals));
                    const tokenPrice = (_a = prices[token]) !== null && _a !== void 0 ? _a : 0;
                    totalTvl = totalTvl.add(tvl.div(scale).mul(new anchor_1.BN(tokenPrice)));
                }
            }
            return totalTvl;
        });
    }
}
exports.StrategyProgram = StrategyProgram;
//# sourceMappingURL=program.js.map